<div class="fn-providers-accounts__container">
  <app-fn-mobile-table-header />
  <div class="fn-providers-accounts__container-table">
    <app-ip-table
      [optionalTitle]="'IP.TABLE.SUPPLIER-ACCOUNTS.TITLE'"
      [tableOption]="tableOptions"
      [propertyOrder]="propertyOrder"
      (action)="onAction($event)"
      [pageItems]="10"
      [filter]="false"
      service="supplier-accounts"
      [dataChange]="dataChange"
    />
  </div>
</div>
  